import { ABSOLUTE_URL_REGEX } from '../../constants/regularExpressions';

export const regex = {
  isExternalHref(redirect: string | null): boolean {
    if (!redirect) return false;
    return redirect.match(ABSOLUTE_URL_REGEX) !== null && !redirect.includes(CONFIG.basePath);
  },

  isInternalHref(redirect: string): boolean {
    return !regex.isExternalHref(redirect);
  },
};
